/**
 * Returns array of Slot objects whos ad unit match given zone
 * @param  {String} zone [description]
 * @return {Array}      [description]
 */
function _findSlots(zone, adIdToSlot, adUnits) {
    return _findAdUnits(zone, adUnits).map(function (adUnit) {
        return adIdToSlot[adUnit.getId()];
    });
}

/**
 * returns array of adUnits matching the given zone
 * @param  {String} zone the refresh zone
 * @param  {Array} adUnits ad units
 * @return {Array}
 */
function _findAdUnits(zone, adUnits) {
    return adUnits.filter(function (adUnit) {
        return (adUnit.getRefreshZones().indexOf(zone) >= 0);
    });
}

module.exports = {
    findSlots: _findSlots,
    findAdUnits : _findAdUnits
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/ad-finder.js
// module id = 445
// module chunks = 36